/**
 * O link que abre o WhatsApp do próprio celular com a mensagem escrita (F135).
 *
 * `wa.me` quer o número internacional só com dígitos — sem `+`, sem
 * parênteses. O cadastro guarda o telefone brasileiro sem o 55
 * (`normalizePhone` só tira a pontuação), então o 55 entra aqui, uma vez.
 *
 * Nulo para o que não é um telefone brasileiro que dê para chamar: um link
 * que abre o WhatsApp num número errado manda a cobrança de um cliente para um
 * estranho.
 */
const BRAZIL = '55';
export const whatsappNumber = (raw) => {
    if (raw == null)
        return null;
    const digits = raw.replace(/\D/g, '');
    // DDD + número: 10 dígitos (fixo) ou 11 (celular).
    if (digits.length === 10 || digits.length === 11) {
        return digits.startsWith('0') ? null : `${BRAZIL}${digits}`;
    }
    // Já com o 55 na frente.
    if ((digits.length === 12 || digits.length === 13) &&
        digits.startsWith(BRAZIL)) {
        return digits;
    }
    return null;
};
export const whatsappLink = (raw, text) => {
    const number = whatsappNumber(raw);
    if (number === null)
        return null;
    const query = text.trim().length === 0 ? '' : `?text=${encodeURIComponent(text)}`;
    return `https://wa.me/${number}${query}`;
};
//# sourceMappingURL=whatsapp.js.map